import {ISentLeadStoredValues} from "../types/ISentLeadStoredValues";

export const emptyLeadStorageData: ISentLeadStoredValues = {
    email: "",
    name: "",
    phone: "",
    rooms: [],
    text: "",
    marketing_email: false,
    marketing_sms: false
};
import {ISentLeadStoredValues} from "../types/ISentLeadStoredValues";

export const emptyLeadStorageData: ISentLeadStoredValues = {
    email: "",
    name: "",
    phone: "",
    rooms: [],
    text: "",
    marketing_email: false,
    marketing_sms: false
};
